// extracted by mini-css-extract-plugin
module.exports = {"footer":"SavedSearchFooter_footer__PDAf5"};